import { LmgService } from "../resource";

const TransModule = {
  namespaced: true,
  state: {
    datas: [],
    cancel: [],
    whts: [],
    data: {},
	isLoading:false,
	// Monotonic counters — every list* call bumps its counter; late responses
	// whose seq != the current counter are dropped so stale results from
	// a slow first query can't overwrite fresh results from a later query.
	_listDataSeq: 0,
	_listWhtSeq: 0,
	_listCancelSeq: 0,
  },
  mutations: {
	SET_CANCEL(state, payload) {
		state.cancel = payload;
	},
	SET_WHTS(state, payload) {
		state.whts = payload;
	},
    SET_DATAS(state, payload) {
      state.datas = payload;
    },
    SET_DATA(state, payload) {
      state.data = payload;
    },
  },
  actions: {
    createData({ commit, state }, payload) {
      return LmgService.TransactionCreate(payload);
    },
    cancelData({ commit, state }, payload) {
      return LmgService.TransactionCancel(payload);
    },
    updatePolicyNumber({ commit, state }, payload) {
      return LmgService.TransactionUpdatePolicyNumber(payload.ID, payload);
    },
    updateDate({ commit, state }, payload) {
      return LmgService.TransactionUpdateDate(payload.ID, payload);
    },
    updateCommissionPaid({ commit, state }, payload) {
      return LmgService.TransactionUpdateCommissionPaid(payload.ID, payload);
    },
    async listData({ commit, state },payload) {
		state._listDataSeq += 1;
		const mySeq = state._listDataSeq;
		state.isLoading = true;
      try {
        const resp = await LmgService.TransactionList(payload);
		if (mySeq !== state._listDataSeq) {
			// A newer listData call was issued while this one was in flight;
			// drop this response to avoid overwriting fresher data.
			return;
		}
		commit("SET_DATAS", resp.data.Data == null ? [] : resp.data.Data);
		state.isLoading = false;
      } catch (err) {
		if (mySeq !== state._listDataSeq) return;
        commit("SET_DATAS", []);
		state.isLoading = false;
      }
    },

	async listWht({ commit, state },payload) {
		state._listWhtSeq += 1;
		const mySeq = state._listWhtSeq;
		state.isLoading = true
        commit("SET_WHTS", []);
		try {
			const resp = await LmgService.WhtList(payload);
			if (mySeq !== state._listWhtSeq) return;
			commit("SET_WHTS", resp.data.Data == null ? [] : resp.data.Data);
			state.isLoading = false
		} catch (err) {
			if (mySeq !== state._listWhtSeq) return;
			console.log(err)
			state.isLoading = false
		}
    },

	async listCancel({ commit, state },payload) {
		state._listCancelSeq += 1;
		const mySeq = state._listCancelSeq;
		state.isLoading = true
        commit("SET_CANCEL", []);
		try {
			const resp = await LmgService.TransactionCancelList(payload);
			if (mySeq !== state._listCancelSeq) return;
			commit("SET_CANCEL", resp.data.Data == null ? [] : resp.data.Data);
			state.isLoading = false
		} catch (err) {
			if (mySeq !== state._listCancelSeq) return;
			console.log(err)
			state.isLoading = false
		}
    },

	async listWhtDetail({ commit, state },payload) {
		state.isLoading = true
        commit("SET_DATAS", []);
		try {
			const resp = await LmgService.TransactionByListID(payload);
			commit("SET_DATAS", resp.data.Data == null ? [] : resp.data.Data);
		state.isLoading = false
		} catch (err) {
			console.log(err)
			state.isLoading = false
		}
    },

	clearTrans({ commit, state }, payload){
		commit("SET_DATAS", []);
	},

	// Fetch a single transaction by ID. Backed by TransactionByListID which
	// accepts a list — we pass [id] and unwrap the first row into `data`.
	// Used by the standalone /lmg/transaction/view/:id detail page.
	async getDetail({ commit }, id) {
		commit("SET_DATA", {});
		const resp = await LmgService.TransactionByListID({ transaction_id_list: [Number(id)] });
		const rows = resp && resp.data && resp.data.Data;
		const row = Array.isArray(rows) && rows.length ? rows[0] : null;
		commit("SET_DATA", row || {});
		return row;
	},
	clearDetail({ commit }) {
		commit("SET_DATA", {});
	},

	createWht({ commit, state }, payload) {
		return LmgService.WhtCreate(payload);
	  },
	  clearWht({ commit, state }, payload) {
		commit("SET_WHTS", []);
	  },

	exportWht({ commit, state }, payload) {
		return LmgService.WhtExport(payload);
	  },

    // --------------- Report ----------------------
    
    ReportDiscount({ commit, state }, payload) {
      return LmgService.ReportDiscount(payload);
    },

	ReportTaxDiscount({ commit, state }, payload) {
		return LmgService.ReportTaxDiscount(payload);
	  },

    CalCommision({ commit, state }, payload) {
      return LmgService.TransactionCalCommision(payload);
    },
  },
  getters: {
    getData(state) {
      return state.datas;
    },
	getWht(state) {
		return state.whts;
	},
	getCancel(state) {
		return state.cancel;
	},
	isLoading(state){
		return state.isLoading;
	},
	getOne(state) {
		return state.data;
	}

  }
};

export default TransModule;
